module.exports = __webpack_public_path__ + "static/img/premium.6fa98a1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/premium.gif
// module id = bDeiN
// module chunks = 4